import React, { useEffect, useState } from "react";
import { StatisticsCard } from "../../admin/Charts/StatisticsCard";
import { PGET } from "../../../api/adminApi";

export default function RoyalStatistics() {
  const [items, setItems] = useState({});

  async function getItems() {
    const data = await PGET(
      "/services/admin/api/royal/dashboard-counts/",
      true,
      {},
    );
    if (data) {
      setItems(data.data);
    }
  }

  useEffect(() => {
    getItems();
  }, []);

  return (
    <div
      className="w-100 g-6 g-xl-8"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "20px",
      }}
    >
      <div>
        <StatisticsCard
          titleColor="white"
          className="card-xl-stretch mb-xl-8"
          svgIcon="/icons/duotune/communication/com014.svg"
          color="#141D76"
          iconColor="white"
          title={items.masterCount?.toLocaleString("en-US")}
          description="Мастеры"
          descriptionColor="white"
        />
      </div>
      <div>
        <StatisticsCard
          className="card-xl-stretch mb-xl-8"
          svgIcon="/icons/duotune/ecommerce/ecm002.svg"
          color={"#E7372C"}
          titleColor="white"
          iconColor="white"
          title={items.salesCount?.toLocaleString("en-US")}
          description="Продажа"
          descriptionColor="white"
        />
      </div>
      <div>
        <StatisticsCard
          className="card-xl-stretch mb-xl-8"
          svgIcon="/icons/duotune/general/gen030.svg"
          color="#25C14C"
          titleColor="white"
          iconColor="white"
          title={items.pointsTotal?.toLocaleString("en-US")}
          description="Набранные баллы"
          descriptionColor="white"
        />
      </div>
      <div>
        <StatisticsCard
          className="card-xl-stretch mb-xl-8"
          svgIcon="/icons/duotune/general/gen031.svg"
          color="#998DEB"
          titleColor="white"
          iconColor="white"
          title={items.usedPointsTotal?.toLocaleString("en-US")}
          description="Использованные баллы"
          descriptionColor="white"
        />
      </div>
      <div>
        <StatisticsCard
          className="card-xl-stretch mb-xl-8"
          svgIcon="/icons/duotune/general/gen055.svg"
          color="#FF9800"
          titleColor="white"
          iconColor="white"
          title={items.mastersRequestCount?.toLocaleString("en-US")}
          description="Запросы мастеров"
          descriptionColor="white"
        />
      </div>
    </div>
  );
}
